<template>
    <div class="h-100 flex flex-column justify-content-between">
        <div class="detail-modal-body" id="detail-modal-body">
            <div class="detail-section">
                <div class="detail-label">{{ dmMessageMode == 'send' ? '宛先' : '差出人' }}</div>
                <div class="detail-sender">{{ message.MessageType == 2 ? message.ExternalName : message.UserName }}</div>
            </div>
            <div class="detail-section">
                <div class="detail-label">種別</div>
                <div class="detail-value">{{ message.MessageTypeName }}</div>
            </div>
            <div class="detail-section">
                <div class="detail-label">日時</div>
                <div class="detail-value">{{ renderTime(message.DisplayTime) }}</div>
            </div>
            <div class="detail-section">
                <div class="detail-subject"><ans-tooltip-span id="message_subject" :value="message.Subject" :parentWidth="450" /></div>
            </div>
            <div class="detail-section">
                <div class="detail-body">
                    <ans-tooltip-span id="message_body" :value="message.Body" :parentWidth="450" />
                </div>
            </div>
        </div>
        <div class="detail-modal-footer">
            <div class="d-flex gap-2">
                <button v-if="showReplyButton" class="btn btn-secondary button_reply" @click="replyMessage">返信</button>
                <button v-if="showUndoButton" class="btn btn-secondary button_reply" @click="undoMessage">送信取り消し</button>
                <button class="btn btn-secondary" @click="closeDetailModal">閉じる</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { MSG_BUTTON, MSG_TITLE, MSG_TYPE } from '@/utils/messages';

export default {
    props: {
        message: { type: Object, required: true }
    },
    computed: {
        ...mapState('app', ['dmMessageMode', 'user']),
        ...mapState('MNG_DM_Message_Store', ['data']),
        showReplyButton() {
            return [1, 3].includes(parseInt(this.message.MessageType)) && this.dmMessageMode == 'receive';
        },
        showUndoButton() {
            return (
                [1, 3].includes(parseInt(this.message.MessageType)) &&
                this.dmMessageMode == 'send' &&
                this.message.CancelFLG == 0 &&
                this.canRecall(this.message.DisplayTime)
            );
        }
    },
    methods: {
        ...mapMutations('app', ['setDmMessageMode', 'updatePopupConfig', 'showModalMessage']),
        ...mapActions('MNG_DM_Message_Store', ['undoSendMessage', 'listDM']),
        renderTime(str) {
            if (!str) return '';

            const date = new Date(str);

            const yyyy = date.getFullYear();
            const MM = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const HH = String(date.getHours()).padStart(2, '0');
            const mm = String(date.getMinutes()).padStart(2, '0');

            return `${yyyy}/${MM}/${dd} ${HH}:${mm}`;
        },
        closeDetailModal() {
            this.$emit('close');
        },
        canRecall(displayTime) {
            const receiveTime = new Date(displayTime);
            const now = new Date();

            const diffMs = now - receiveTime;
            const diffMinutes = diffMs / 1000 / 60;

            return diffMinutes <= 5;
        },
        undoMessage() {
            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: MSG_TITLE.C002,
                content: '送信してもよろしいですか？',
                cancelText: MSG_BUTTON.cancelText,
                okText: MSG_BUTTON.okText,
                callback: () => {
                    this.undoSendMessage({
                        params: {
                            CompanyCD: this.user.company_cd,
                            MessageNo: this.message.MessageNo
                        },
                        callback: () => {
                            this.showModalMessage({
                                type: MSG_TYPE.SUCCESS,
                                title: '報告',
                                content: '送信しました。',
                                okText: 'OK'
                            });
                            this.closeDetailModal();
                            this.listDM({
                                params: {
                                    CompanyCD: this.user.company_cd,
                                    UserID: this.user.EmployeeCD,
                                    Mode: 2,
                                    Keyword: this.data.Keyword,
                                    TargetDate: this.data.TargetDate
                                }
                            });
                        }
                    });
                }
            });
        },
        replyMessage() {
            this.closeDetailModal();
            this.updatePopupConfig({ title: '新規DM作成' });
            this.setDmMessageMode('compose');
            const quotedBody = this.message.Body?.split('\n')
                .map((line) => '> ' + line)
                .join('\n');

            this.data.internal = {
                isReply: true,
                MDCD: this.message.MDCD,
                MDName: this.message.MDName,
                EmployeeCD: this.message.PartnerUserID,
                EmployeeName: this.message.UserName,
                Subject: 'Re: ' + this.message.Subject,
                Body: '\n\n' + quotedBody
            };
        }
    }
};
</script>
<style>
.button_reply {
    background-color: #eda618 !important;
}
.detail-modal-body {
    padding: 24px;
    overflow-y: auto;
    flex: 1;
}
.detail-section {
    margin-bottom: 20px;
}
.detail-label {
    font-size: 12px;
    color: #6c757d;
    font-weight: 600;
    margin-bottom: 6px;
    text-transform: uppercase;
}
.detail-sender {
    font-size: 16px;
    font-weight: 600;
    color: #212529;
}
.detail-value {
    font-size: 14px;
    color: #212529;
}
.detail-value {
    font-size: 14px;
    color: #212529;
}
.detail-subject .move-tooltip-span {
    font-size: 20px;
    font-weight: 600;
    color: #212529;
    margin-bottom: 16px;
}
.detail-body {
    font-size: 14px;
    line-height: 1.6;
    color: #495057;
    white-space: pre-wrap;
}
.detail-modal-footer {
    padding: 16px 20px;
    background: #f8f9fa;
    border-top: 1px solid #e1e8ed;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    .btn-secondary {
        background: #6c757d;
        color: white;
    }
    .btn {
        padding: 10px 24px;
        border: none;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
    }
}
</style>
